import React, { useEffect } from "react";

import {
  collection,
  query,
  doc,
  updateDoc,
  getCountFromServer,
} from "firebase/firestore";
import {
  useFirestore,
  useFirestoreCollectionData,
  useFirestoreDocData,
} from "reactfire";
import { useGame } from "context/gameContext";
import { useUser } from "reactfire";

const GameData = () => {
  const { data: user } = useUser();
  const { dispatch } = useGame();
  const firestore = useFirestore();

  const settingsCollection = collection(firestore, "settings");
  const settingsQuery = query(settingsCollection);

  // get general game settings
  const { status: settingsStatus, data: settingsData } =
    useFirestoreCollectionData(settingsQuery, {
      idField: "id",
    });

  useEffect(() => {
    if (settingsData) {
      dispatch({ type: "setSettings", value: settingsData });
    }
  }, [settingsData]);

  const leagueCollection = collection(firestore, "leagues");
  const leagueQuery = query(leagueCollection);

  // get general game settings
  const { status: leagueStatus, data: leagueData } = useFirestoreCollectionData(
    leagueQuery,
    {
      idField: "id",
    }
  );

  useEffect(() => {
    if (leagueData) {
      // create a map with only the id an premium parameter from leagueData
      const leagueDataShort = leagueData.map((league) => ({
        id: league.id,
        premium: league.premium,
      }));

      dispatch({ type: "setLeagues", value: leagueDataShort });
    }
  }, [leagueData]);

  const gameListCollection = collection(firestore, "gameList");
  const gameListQuery = query(gameListCollection);

  // get general game settings
  const { status: gameListStatus, data: gameListData } =
    useFirestoreCollectionData(gameListQuery);

  useEffect(() => {
    if (gameListData) {
      dispatch({ type: "setGameList", value: gameListData });
    }
  }, [gameListData]);

  // TODO: DELETE THIS AND REMOVE FROM GAME
  const userMessagesCollection = collection(
    firestore,
    "users/" + user?.uid + "/messages"
  );
  const userMessagesQuery = query(userMessagesCollection);

  const { status: userMessagesStatus, data: userMessages } =
    useFirestoreCollectionData(userMessagesQuery, {
      idField: "id",
    });

  useEffect(() => {
    if (userMessages) {
      dispatch({ type: "setUserMessages", value: userMessages });
    }
  }, [userMessages]);

  // TODO: DELETE THIS AND REMOVE FROM GAME

  /*   const gameUsersCollection = collection(firestore, "users");
  const gameUsersQuery = query(gameUsersCollection);

  const { status: gameUsersStatus, data: gameUsers } =
    useFirestoreCollectionData(gameUsersQuery, {
      idField: "id",
    });

  useEffect(() => {
    if (gameUsers) {
      dispatch({ type: "setGameUsers", value: gameUsers });
    }
  }, [gameUsers]); */

  async function getCount() {
    const gameUsersCollection = collection(firestore, "users");
    const userCount = await getCountFromServer(gameUsersCollection);
    if (userCount.data().count) {
      dispatch({ type: "setGameUsers", value: userCount.data().count });
    }
  }
  useEffect(() => {
    getCount();
  }, []);
  // get logged in user game data
  const userDocRef = doc(firestore, "users", user?.uid);
  const { status: userDataStatus, data: userDataDoc } = useFirestoreDocData(
    userDocRef,
    {
      idField: "id",
    }
  );

  useEffect(() => {
    if (userDataDoc) {
      dispatch({ type: "setUserGameData", value: userDataDoc });
    }
  }, [userDataDoc]);

  useEffect(() => {
    if (user) {
      let userData = user?.auth?.currentUser;
      if (
        userData?.providerData[0]?.providerId == "apple.com" &&
        userData?.metadata?.creationTime == userData?.metadata?.lastSignInTime
      ) {
        updateDoc(userDocRef, {
          name: user?.displayName,
          photo: user?.photoURL,
        });
      }
    }
  }, [user]);

  return null;
};

export default GameData;
